import { UserTypeEnum } from '../types/user'

const ADMIN_EMAIL = 'totnarek@gmail.com'

/** True if the user can update match/race results (admin only). */
export function isAdminUser(user: { type?: string; email?: string } | null): boolean {
  if (!user) return false
  if (user.type === UserTypeEnum.Admin) return true
  if (user.email && String(user.email).toLowerCase() === ADMIN_EMAIL) return true
  return false
}

/** True only for the specific account allowed to download News posters. */
export function canDownloadNewsPosters(user: { email?: string } | null): boolean {
  return Boolean(user?.email && String(user.email).toLowerCase() === ADMIN_EMAIL)
}
